import { safeDefine } from "../../registration/safe-define.js";
import { TooltipGroupElement } from "../../ui/tooltip/group.js";
//#region src/define/ui/tooltip-group.ts
safeDefine(TooltipGroupElement);
//#endregion

//# sourceMappingURL=tooltip-group.js.map